'use client'

import { COOKIE_CONSENT_OPEN_EVENT } from '@/components/cookie-consent-banner'

export default function CookiePreferencesButton({
  className = '',
  children = 'Cookie Preferences',
}) {
  return (
    <button
      type="button"
      className={className}
      onClick={() => window.dispatchEvent(new Event(COOKIE_CONSENT_OPEN_EVENT))}
    >
      {children}
    </button>
  )
}
